// extracted by mini-css-extract-plugin
export var background = "_5v-0";
export var buttonPrimary = "_5v-1";
export var container = "_5v-2";
export var containerTopLayerApi = "_5v-3";
export var feature = "_5v-6";
export var featureBody = "_5v-7";
export var featureIcon = "_5v-8";
export var featureSummary = "_5v-a";
export var featureTitle = "_5v-9";
export var modal = "_5v-g";
export var modalAction = "_5v-f";
export var modalCloseButton = "_5v-e";
export var modalFeatures = "_5v-5";
export var modalFooter = "_5v-b";
export var modalImageLogo = "_5v-c";
export var modalLogo = "_5v-d";
export var redoModal = "_5v-4";